/* eslint-disable import/no-unresolved */
/* eslint-disable max-lines-per-function */
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { Calendar } from 'primereact/calendar';
import React, { useContext } from 'react';
import { BiCalendarPlus } from 'react-icons/bi';
import { VscSave } from 'react-icons/vsc';
import { ptBR } from '../calendarLocation';
import CurrencyInput from './CurrencyInput.jsx';
import EdicaoPrecoMensalidadeContext from '../context/EdicaoMensalidadeContext';
import { Checkbox } from '@material-ui/core';
import ValorComDesconto from './ValorComDesconto.jsx';
import { mensalidadesSchema } from '../validation/yupMensalidadeSchema';
import ValorBase from './ValorBase.jsx';
import CheckboxAtualizarSomente from './checkboxAtualizarSomente';
import Status from './status';

const amanha = new Date();

amanha.setDate(amanha.getDate() + 1);

export default function FormMensalidadeEmLote({ handleFormSubmit, handleFormAgendamento }) {
    const { lotePrecoMensalidadeContextState } = useContext(EdicaoPrecoMensalidadeContext);

    const isPlanoZTASelecionado = Boolean(lotePrecoMensalidadeContextState?.planosSelecionados.find(plano => plano.plano === 'ZTA'));

    const isButtonAgendarDisabled = values => {
        const { dataAgendamento, atualizarSomenteStatus, atualizarSomenteValorDesconto, valorBase, planoZTA } = values;

        if (dataAgendamento === '' || dataAgendamento === null) {
            return true;
        }

        if ((valorBase === '' && !planoZTA) && !atualizarSomenteStatus && !atualizarSomenteValorDesconto) {
            return true;
        }

        return false;
    };

    const isButtonSalvarDisabled = values => {
        const { dataAgendamento, valorBase } = values;

        if ((dataAgendamento !== '' && dataAgendamento !== null) || (valorBase === '' && !isPlanoZTASelecionado)) {
            return true;
        }

        return false;
    };

    return (
        <Formik
            initialValues={{
                planoZTA: isPlanoZTASelecionado,
                valorBase: '',
                valorDesconto: '',
                dataAgendamento: '',
                dataInicioDesconto: '',
                dataFinalDesconto: '',
                atualizarSomenteValorDesconto: false,
                valorFinal: '',
                pagamentoCartao: false,
                pagamentoBoleto: false,
                pagamentoEscelsa: false,
                formasPagamento: '',
                atualizarSomenteStatus: false,
                status: 1
            }}
            validationSchema={mensalidadesSchema}
            onSubmit={handleFormSubmit}
            validateOnChange={true}
        >
            {({

                resetForm,
                values

            }) => (
                <Form
                    className="form-cadastro-edicao-planos"
                    style={lotePrecoMensalidadeContextState.loadEnvioPlanos ? { display: 'none' } : {}}
                >
                    <div className="header-form-dados">
                        <div className="header-form-dados-title">
                            <h2>Dados da mensalidade</h2>
                            <p>
                                Defina as caracteristicas que as mensalidades
                                irão receber
                            </p>
                        </div>
                    </div>
                    <div className='checkboxDiv'>
                        <CheckboxAtualizarSomente />
                    </div>
                    <div className='p-grid'>

                        <div className='p-col-4'>
                            <ValorBase />
                        </div>
                        <div className='p-col-4'>
                            <Field
                                maskOptions={{
                                    integerLimit: 4,
                                    thousandsSeparatorSymbol: ''
                                }}
                                as={CurrencyInput}
                                name="valorDesconto"
                                id="valorDesconto"
                                placeholder="Valor do desconto"
                                disabled={values.atualizarSomenteStatus}
                            />
                            <ErrorMessage
                                component="span"
                                name="valorDesconto"
                                style={{ color: 'red' }}
                            />
                        </div>
                        <div className='p-col-4'>
                            <ValorComDesconto />
                        </div>
                        <div className='p-col-4'>
                            <Field
                                as={Calendar}
                                name="dataInicioDesconto"
                                id="dataInicioDesconto"
                                locale={ptBR}
                                placeholder="Data inicio desconto"
                                minDate={amanha}
                                style={{ width: '100%' }}
                                dateFormat="dd/mm/yy"
                                disabled={values.atualizarSomenteStatus}
                            />
                            <ErrorMessage
                                component="span"
                                name="dataInicioDesconto"
                                style={{ color: 'red' }}
                            />
                        </div>
                        <div className='p-col-4'>
                            <Field
                                as={Calendar}
                                name="dataFinalDesconto"
                                id="dataFinalDesconto"
                                locale={ptBR}
                                placeholder="Data final desconto"
                                minDate={amanha}
                                style={{ width: '100%' }}
                                dateFormat="dd/mm/yy"
                                disabled={values.atualizarSomenteStatus}
                            />
                            <ErrorMessage
                                component="span"
                                name="dataFinalDesconto"
                                style={{ color: 'red' }}
                            />
                        </div>
                        <div className='p-col-4'>
                            <Field
                                as={Calendar}
                                name="dataAgendamento"
                                id="dataAgendamento"
                                locale={ptBR}
                                placeholder="Data agendamento"
                                minDate={amanha}
                                style={{ width: '100%' }}
                                dateFormat="dd/mm/yy"
                            />
                            <ErrorMessage
                                component="span"
                                name="dataAgendamento"
                                style={{ color: 'red' }}
                            />
                        </div>

                        <div className='p-col-4' style={{
                            display: 'flex',
                            justifyContent: 'space-between'
                        }}>
                            <div className='checkboxDivFormasPagamento'>
                                <Field
                                    as={Checkbox}
                                    name='pagamentoCartao'
                                    id='pagamentoCartao'
                                    color='primary'
                                    disabled={values.atualizarSomenteStatus}
                                />
                                <label className="p-checkbox-label">Cartão</label>
                            </div>
                            <div className='checkboxDivFormasPagamento'>
                                <Field
                                    as={Checkbox}
                                    name='pagamentoBoleto'
                                    id='pagamentoBoleto'
                                    color='primary'
                                    disabled={values.atualizarSomenteStatus}
                                />
                                <label className="p-checkbox-label">Boleto</label>
                            </div>
                            <div className='checkboxDivFormasPagamento'>
                                <Field
                                    as={Checkbox}
                                    name='pagamentoEscelsa'
                                    id='pagamentoEscelsa'
                                    color='primary'
                                    disabled={values.atualizarSomenteStatus}
                                />
                                <label className="p-checkbox-label">Escelsa</label>
                            </div>
                            <ErrorMessage
                                component="span"
                                name="formasPagamento"
                                style={{ color: 'red' }}
                            />
                        </div>
                        <div className='p-col-4'>
                            <Status />
                        </div>

                        <div className="actions-form">
                            <button type="submit"
                                disabled={isButtonSalvarDisabled(values)}
                            >
                                <VscSave size={18} color="white" />
                                <span>Salvar</span>
                            </button>
                            <button
                                disabled={isButtonAgendarDisabled(values)}
                                onClick={handleFormAgendamento.bind(
                                    this,
                                    values,
                                    resetForm
                                )}
                                type="button"
                            >
                                <BiCalendarPlus size={22} color="white" />
                                <span>Agendar</span>
                            </button>
                        </div>
                    </div>
                </Form>
            )}
        </Formik>
    );
}
